import { render, staticRenderFns } from "./addjackpot.vue?vue&type=template&id=0a68d0ca&"
import script from "./addjackpot.vue?vue&type=script&lang=js&"
export * from "./addjackpot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports